import { v2 } from '@saucelabs/sl-module-builds';

export const NAMESPACE = 'job-details-build-vdc';

export const buildTypes = v2.common.types.createVDCTypes(NAMESPACE);
